
import { TheCard } from 'flowbite-vue'
    export default {
        name: "Projects",
        components: {
          TheCard
        }
    }
